import Date from './Date';

export default Date;
